import Vue from "vue";

export const JobScheduleTeamEventBus = new Vue();
